// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"a2b07335","362":"f5f635ce","453":"b9568c39","477":"b651005d","928":"b874e71a"}[chunkId] + ".chunk.js";
};